/*
 * Toolworld – R12 privat/erhverv (moms).
 *
 * - Vælgere: alle elementer med [data-tw-vat-set="incl|excl"].
 * - Valget gemmes i cookien tw_vat og afspejles i html[data-tw-vat],
 *   som snippets/tw-head.liquid allerede har sat ved sideindlæsning.
 * - Popup "Hvordan handler du?" vises ved første besøg, men først når
 *   cookievalget er truffet (Shopify Customer Privacy API).
 * - Sikrer, at Shopify.formatMoney er pakket ind (se snippets/tw-head.liquid).
 */
(function () {
  'use strict';

  var tw = (window.twVat = window.twVat || {});
  var html = document.documentElement;
  var COOKIE = 'tw_vat';
  var ONE_YEAR = 60 * 60 * 24 * 365;

  if (typeof tw.install === 'function') tw.install();

  tw.get = function () {
    return html.getAttribute('data-tw-vat') === 'excl' ? 'excl' : 'incl';
  };

  tw.hasChoice = function () {
    return new RegExp('(?:^|; )' + COOKIE + '=(incl|excl)').test(document.cookie);
  };

  tw.set = function (mode) {
    mode = mode === 'excl' ? 'excl' : 'incl';
    document.cookie = COOKIE + '=' + mode + '; path=/; max-age=' + ONE_YEAR + '; SameSite=Lax';
    html.setAttribute('data-tw-vat', mode);
    syncToggles();
    document.dispatchEvent(new CustomEvent('tw:vat-change', { detail: { mode: mode } }));
  };

  function syncToggles() {
    var mode = tw.get();
    var buttons = document.querySelectorAll('.tw-vat-toggle [data-tw-vat-set], .tw-vat-dropdown [data-tw-vat-set]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-pressed', String(buttons[i].getAttribute('data-tw-vat-set') === mode));
    }
  }

  // Popup

  function popup() {
    return document.getElementById('tw-vat-popup');
  }

  function openPopup() {
    var dialog = popup();
    if (!dialog || tw.hasChoice() || dialog.open) return;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function closePopup() {
    var dialog = popup();
    if (!dialog || !dialog.open) return;
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  // Har besøgende faktisk svaret på cookiebanneret? (RETTELSER-1 punkt 10)
  // shouldShowBanner() forbliver true efter et valg, og currentVisitorConsent() giver "no"
  // som standard, før der er svaret (set 2026-10-04). getTrackingConsent() skelner:
  // 'yes' / 'no' = svaret, 'no_interaction' = ikke svaret.
  function consentAnswered(privacy) {
    if (typeof privacy.getTrackingConsent !== 'function') return false;
    var state = privacy.getTrackingConsent();
    return state === 'yes' || state === 'no';
  }

  // Kalder cb, når besøgende har truffet sit cookievalg – eller med det samme,
  // hvis valget allerede er truffet, banneret ikke kræves, eller API'et ikke er tilgængeligt.
  function whenConsentSettled(cb) {
    var done = false;
    function go() {
      if (done) return;
      done = true;
      cb();
    }

    var S = window.Shopify;
    if (!S || typeof S.loadFeatures !== 'function') return go();

    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (error || !privacy) return go();

      var bannerRequired = typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner();
      if (!bannerRequired || consentAnswered(privacy)) return go();

      document.addEventListener('visitorConsentCollected', go, { once: true });
    });
  }

  // Events

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-tw-vat-set]');
    if (!button) return;
    event.preventDefault();
    tw.set(button.getAttribute('data-tw-vat-set'));
    closePopup();
    closeDropdowns();
  });

  // Mobilens dropdown i topbjælken (snippets/tw-vat-dropdown.liquid) lukkes efter valg og ved klik udenfor
  function closeDropdowns(except) {
    var open = document.querySelectorAll('[data-tw-vat-dropdown][open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].removeAttribute('open');
    }
  }

  document.addEventListener('click', function (event) {
    closeDropdowns(event.target.closest && event.target.closest('[data-tw-vat-dropdown]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDropdowns();
  });

  document.addEventListener('close', function (event) {
    // Lukket med Esc uden valg: Privat (inkl. moms) er standard og huskes.
    if (event.target === popup() && !tw.hasChoice()) tw.set('incl');
  }, true);

  function init() {
    syncToggles();
    var designMode = window.Shopify && window.Shopify.designMode;
    if (!tw.hasChoice() && !designMode) whenConsentSettled(openPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
